export const DriverStatusCssClasses = ["danger", "success", "info", ""];
export const DriverStatusTitles = ["Active", "Inactive", "Deleted", "Suspend", ""];
export const DriverTypeCssClasses = ["danger", "success", ""];
export const DriverTypeTitles = ["Support", "Driver", "Super Driver"];
export const AVAILABLE_GENDERS = ["Male", "Female"];
export const YESNO_OPTIONS = ["Yes", "No"];
export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    lname: "",
    fname: "",
    email: "",
    ipAddress: ""
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10
};
